import React from 'react';
import axios from 'axios';
import { PieChart, Pie, Tooltip, Cell } from 'recharts';
import { Table, Form, Header, Segment, Loader, Grid } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl'; import { fetchFaculties, fetchAcademicYears, fetchStudyCycle } from '../Lookups/util';
import { center, customLabel, colorss } from './util';

axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
//axios.defaults.crossDomain = true;

class EnrolledStudentsPerStudyYearAndCycle extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            faculties: [],
            faculty: '',
            academicYears: [],
            academicYear: '',
            data1: [],
            data2: [],

            loading: true,
            showChart: false
        };

        this.fetchFacultiesAcademicYearsAndStudyCycle = this.fetchFacultiesAcademicYearsAndStudyCycle.bind(this);
        this.generateChartData = this.generateChartData.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.getFacultyName = this.getFacultyName.bind(this);
        this.getAcademicYearName = this.getAcademicYearName.bind(this);
        this.getStudyCycleName = this.getStudyCycleName.bind(this);
        this.transformData = this.transformData.bind(this);
        this.transform = this.transform.bind(this);
        this.getStudyYearName = this.getStudyYearName.bind(this);
    }


    componentDidMount() {
        this.fetchFacultiesAcademicYearsAndStudyCycle();
    }

    getFacultyName() {
        const { faculties, faculty } = this.state;
        const selected = faculties.find(el => el.id === faculty);
        if (selected && selected.name) return selected.name;
        return '';
    }

    getStudyCycleName(id) {
        const { studyCycles } = this.state;
        const selected = studyCycles.find(el => el.id === id);
        if (selected && selected.displayName) return selected.displayName;
        return '';
    }

    getAcademicYearName() {
        const { academicYear, academicYears } = this.state;
        const selected = academicYears.find(el => el.id === academicYear);
        if (selected && selected.name) return selected.name;
        return '';
    }
    getStudyYearName(id) {
        if (id === 1) return 'I';
        else if (id === 2) return 'II';
        else if (id === 3) return 'III';
        else if (id === 4) return 'IV';
        else if (id === 5) return 'V';
        else if (id === 6) return 'VI';
        return '';
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    fetchFacultiesAcademicYearsAndStudyCycle() {
        axios.all([fetchFaculties(), fetchAcademicYears(), fetchStudyCycle()])
            .then(axios.spread((facultiesRes, academicYearsRes, studycyclesRes) => {
                const faculties = facultiesRes.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));
                const academicYears = academicYearsRes.data.reverse().map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));
                const studyCycles = studycyclesRes.data.map(el => ({ ...el, value: el.id, name: el.name }));
                this.setState({
                    academicYears, faculties, studyCycles, loading: false
                });
            }))
            .catch(err => {
                this.setState({ error: true, loading: false });
                console.log('Failed to fetch faculties, academic years or study cycle');
            });
    }

    transformData(data) {
        const data_ = data.reduce((acc, val) => {
            if (Object.prototype.hasOwnProperty.call(acc, val.studyCycle)) {
                acc[val.studyCycle] = { ...acc[val.studyCycle], [val.studyYear]: val.numberOfStudents };
                return acc;
            }
            acc[val.studyCycle] = { [val.studyYear]: val.numberOfStudents };
            return acc;
        }, {});

        return Object.keys(data_).map(key => ({ studyCycle: key, ...data_[key] }));
    }

    generateChartData() {
        const { faculty, academicYear } = this.state;
        axios.get(`/statistics/enrolled-per-study-year-and-study-cycle?facultyId=${faculty}&academicYearId=${academicYear}`)
            .then(res => {
                const data1 = res.data.map(el => ({
                    ...el, studyCycle: this.getStudyCycleName(el.studyCycleId), name: this.getStudyYearName(el.studyYear), value: el.numberOfStudents
                }));
                const transformedData = this.transformData(data1).map(el => (this.transform(el)));
                this.setState({ data1, data2: transformedData, showChart: true });
            })
            .catch(err => {
                this.setState({ error: true, });
                console.log('Failed to fetch results');
            });
    }

    transform(a) {
        const sum = Object.keys(a).reduce((acc, val) =>
            val === 'studyCycle' ? acc : parseInt(acc,10) + parseInt(a[val],10), 0);
        return { name: a.studyCycle, value: sum };
    }

    render() {
        const { data1, data2 } = this.state;

        if (this.state.loading) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;
        return (
            <div>
                <Header as="h1">{<FormattedMessage id="statistics.statistic" />}</Header>
                <Segment.Group raised>
                    <Segment clearing>
                        <Header as="h3">
                            {<FormattedMessage id="statistics.selectFacultyAndAcademicYear" />}
                        </Header>
                    </Segment><Segment>
                        <Form>
                            <Form.Group widths="equal">
                                <Form.Field>
                                    <label>{<FormattedMessage id="common.faculty" />}</label>
                                    <Form.Dropdown
                                        placeholder={<FormattedMessage id="statistics.selectFaculty" />}
                                        value={this.state.faculty}
                                        onChange={this.handleInputChange}
                                        name="faculty"
                                        options={this.state.faculties}
                                        search
                                        fluid
                                        selection
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <label>{<FormattedMessage id="common.academicYear" />}</label>
                                    <Form.Dropdown
                                        placeholder={<FormattedMessage id="statistics.selectAcademicYear" />}
                                        value={this.state.academicYear}
                                        onChange={this.handleInputChange}
                                        name="academicYear"
                                        options={this.state.academicYears}
                                        search
                                        fluid
                                        selection
                                    />
                                </Form.Field>

                                <Form.Button label=" " color="blue" basic="true" onClick={this.generateChartData}>{<FormattedMessage id="common.show" />}</Form.Button>
                            </Form.Group>
                        </Form>
                    </Segment>
                </Segment.Group>

                {this.state.showChart && <Grid columns="equal" centered className="stackable">
                    <Grid.Row stretched>
                        <Grid.Column>
                            <Header as="h2">
                                {this.getFacultyName()}
                            </Header>
                            <Header as="h3">{<FormattedMessage id="statistics.headerNumberEnrolledStudentsPerAcademicYearsAndCycles" />} {this.getAcademicYearName()} {<FormattedMessage id="statistics.headerAcademicYear" />}</Header>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row stretched>
                        <Grid.Column>
                            <Segment.Group raised style={{ backgroundColor: 'white' }}>
                                <Segment>
                                    <Header as="h3">{<FormattedMessage id="statistics.tableShow" />}</Header>
                                </Segment>
                                {data1.length ? <Segment>
                                    <Table compact celled selectable>
                                        <Table.Header>
                                            <Table.Row>
                                                <Table.HeaderCell>{<FormattedMessage id="common.studyCycle" />}</Table.HeaderCell>
                                                <Table.HeaderCell>{<FormattedMessage id="statistics.studyYear" />}</Table.HeaderCell>
                                                <Table.HeaderCell>{<FormattedMessage id="statistics.numberOfStudents" />}</Table.HeaderCell>
                                            </Table.Row>
                                        </Table.Header>
                                        <Table.Body>  {data1.map((el) =>

                                            (<Table.Row key={el.value}>
                                                <Table.Cell verticalAlign="middle">
                                                    {el.studyCycle}
                                                </Table.Cell>
                                                <Table.Cell verticalAlign="middle">
                                                    {el.name}
                                                </Table.Cell>
                                                <Table.Cell verticalAlign="middle">
                                                    {el.value}
                                                </Table.Cell>
                                            </Table.Row>))}
                                        </Table.Body>
                                    </Table>
                                    <br />
                                </Segment>
                                    : <Segment>
                            Nema podataka za odabranu akademsku godinu.
                                    </Segment>}
                            </Segment.Group >
                        </Grid.Column>

                        <Grid.Column>
                            <Segment.Group raised>
                                <Segment>
                                    <Header as="h3">{<FormattedMessage id="statistics.graphicShow" />}</Header>
                                </Segment>
                                {data2.length ? <Segment>
                                    <br />
                                    <PieChart style={center} width={390} height={350}>
                                        <Pie
                                            data={data2}
                                            outerRadius={60}
                                            labelLine={false}
                                            fill="#003b61"
                                            paddingAngle={9}
                                        />
                                        <Pie
                                            data={data1}
                                            innerRadius={70}
                                            outerRadius={120}
                                            paddingAngle={5}
                                            label={customLabel}
                                        >
                                            {
                                                data1.map((entry, index) => <Cell fill={colorss[index % colorss.length]} />)
                                            }
                                        </Pie>
                                        <Tooltip />
                                    </PieChart>

                                    <br />
                                </Segment>
                                    : <Segment>
                                Nema podataka za odabranu akademsku godinu.
                                    </Segment>}
                            </Segment.Group>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>}
            </div>
        );
    }
}

export default EnrolledStudentsPerStudyYearAndCycle;



// WEBPACK FOOTER //
// ./src/views/Statistics/EnrolledStudentsPerStudyYearAndCycle.js